module.exports = __webpack_public_path__ + "img/logo.fe5d1add.svg";